const DEFAULT_STATE = {
  redacs: [],
  sites: [],
  periods: [],
  redacsSetup: [],
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getRedacs: (state) => state.redacs,
    getSites: (state) => state.sites,
    getPeriods: (state) => state.periods,
    getRedacsSetup: (state) => state.RedacsSetup,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setRedacs(state, payload) {
      state.redacs = payload;
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setPeriods(state, payload) {
      state.periods = payload;
    },
    setRedacsSetup(state, payload) {
      state.redacsSetup = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    setRedacs(context, payload) {
      context.commit("setRedacs", payload);
    },
    setSites(context, payload) {
      context.commit("setSites", payload);
    },
    setPeriods(context, payload) {
      context.commit("setPeriods", payload);
    },
    setRedacsSetup(context, payload) {
      context.commit("setRedacsSetup", payload);
    },
  },
};
